import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";

const PrivacyPolicyOnly = () => {
	async function getText(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/privacy").then((r)=>r.json().then((json)=>{
            return json
        }))
    }

    const location = useLocation()
	const [text,setText] = useState("")

	useEffect(() => {
		document.querySelector("title").textContent = "Privacy Policy - アワートAI"
		getText().then(r=>{
			if(r.result){
				setText(r.text)
			}
		})
	},[location.pathname])

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Container className='text-center'>
            <img src='/img/ourt_logo_dashed.png' height={70} />
        </Container>
        <Container className='w-100 mt-3' dangerouslySetInnerHTML={{__html: text}} />
    </div>
    )
}

export default PrivacyPolicyOnly;
